<template>
  <aside class="sidenote">
    <slot></slot>
  </aside>
</template>

<script>
export default {
  name: "Sidenote"
};
</script>

<style lang="scss" scoped>
.sidenote {
  color: $primary-color;
  font-weight: 600;
  font-size: 15px;
  height: fit-content;
  position: absolute;
  top: 25px;
  right: 0;

  & > *:not(div) {
    line-height: 2.13;
    font-size: inherit;
    padding-bottom: 25px;
  }

  & > * {
    position: relative;
  }

  & > *::after {
    content: "";
    position: absolute;
    bottom: -0px;
    left: 0;
    display: block;
    height: 1px;
    width: 100%;
    background-color: $black-color;
  }

  & > *:not(:first-child) {
    margin-top: 25px;
  }
}

@media (max-width: $tablet) {
  .sidenote {
    display: none;
  }
}
</style>